let contentType = 'application/json';
let listLoginProcessUrl = window.config.host + '/auth/loginProcess/listLoginProcess';
window.$.ajax({
    type: 'get',
    async: false,
    url: listLoginProcessUrl,
    dataType: 'json',
    data: { sysId: window.app.sPlatformFlg },
    contentType: contentType,
    beforeSend: function(request) {
        request.setRequestHeader('languageType', window.vue.$i18n.locale);
    },
    success: function(response) {
        if (response.content) {
            if (response.content !== null && response.content !== undefined) {
                window.validateLogon.loginPorcess = response.content.mustVerifyLoginProcessList;
            }
        }
    }
});
